"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Autocomplete;

var _Autocomplete2 = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

require("regenerator-runtime/runtime");

var _react = _interopRequireWildcard(require("react"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _InputField = _interopRequireDefault(require("./InputField"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Autocomplete(_ref) {
  var autoFocus = _ref.autoFocus,
      error = _ref.error,
      getOptions = _ref.getOptions,
      icon = _ref.icon,
      inputFieldStyles = _ref.inputFieldStyles,
      onEnter = _ref.onEnter,
      open = _ref.open,
      placeholder = _ref.placeholder,
      setOpen = _ref.setOpen,
      setValue = _ref.setValue,
      value = _ref.value,
      width = _ref.width;

  // Enforce some mandatory props - a developer error if they are missing
  if (open === undefined || setOpen === undefined || onEnter === undefined) {
    throw Error("Missing some mandatory props");
  }

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0, _react.useState)("disabled"),
      _useState6 = _slicedToArray(_useState5, 2),
      iconColor = _useState6[0],
      setIconColor = _useState6[1];

  var updateInputValue = function updateInputValue(newValue) {
    // Replace the input value with its equivalent in the list
    // of options to resolve any differences in character case
    var optionValue = options.find(function (option) {
      return option.toLowerCase() === (newValue === null || newValue === void 0 ? void 0 : newValue.toLowerCase());
    });
    setValue(optionValue || newValue);
  };

  var onKeyDown = function onKeyDown(event) {
    if (event.keyCode === 13) {
      // The Enter key
      updateInputValue(event.target.value);

      if (!open) {
        onEnter();
      }

      setOpen(false);
    }

    if (event.keyCode === 27) {
      // Esc key
      setOpen(false);
    }
  };

  var onChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
      var newValue, newOptions;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newValue = event.target.value;
              setValue(newValue);
              setLoading(true);
              _context.next = 5;
              return getOptions(newValue);

            case 5:
              newOptions = _context.sent;
              setOptions(newOptions);
              setOpen(newOptions.length > 0);
              setLoading(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var useStyles = (0, _makeStyles["default"])(function (theme) {
    return {
      root: {
        width: width
      },
      errorStyles: {
        borderColor: theme.custom.colour.red100,
        flexGrow: 1,
        "& input": {
          padding: 10
        },
        "&:hover": {
          borderColor: theme.custom.colour.red100
        },
        "&:focus-within": {
          borderColor: theme.custom.colour.red100
        }
      }
    };
  });
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
    autoSelect: true,
    blurOnSelect: true,
    className: classes.root,
    disableOpenOnFocus: true,
    freeSolo: true,
    open: open,
    value: value,
    options: options,
    onFocus: function onFocus() {
      setIconColor("action");
    },
    onChange: function onChange(event, val) {
      updateInputValue(val);
    },
    onBlur: function onBlur() {
      setIconColor("disabled");
      setOpen(false);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_InputField["default"], {
        width: width,
        autoFocus: autoFocus,
        params: params,
        loading: loading,
        placeholder: placeholder,
        icon: icon,
        iconColor: error ? "error" : iconColor,
        errorStyles: error ? classes.errorStyles : null,
        onChange: onChange,
        onKeyDown: onKeyDown,
        inputFieldStyles: inputFieldStyles
      });
    }
  });
}